import { type ComputedRef, computed } from 'vue'
import { useRoute } from 'vue-router'

import { parsePageQuery } from '@/router/query-params'

/* NaN for a present but invalid page — callers decide between 404 and a fallback */
export function usePageQuery(): ComputedRef<number> {
    const route = useRoute()

    return computed(() => parsePageQuery(route.query))
}
